import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronDown } from 'lucide-react';

const AdminMenuGrid = ({ title, breadcrumb, items }) => {
  const navigate = useNavigate();

  return (
    <div className="fade-in" data-testid={`hub-${title.toLowerCase().replace(/\s/g, '-')}`}>
      <div className="flex items-center gap-2 text-xs text-gray-500 mb-6">
        {breadcrumb.map((b, i) => (
          <React.Fragment key={i}>
            {i > 0 && <span className="text-gray-300">|</span>}
            <span className={i === breadcrumb.length - 1 ? 'text-[#1f1f1f] font-medium uppercase tracking-wider' : 'uppercase tracking-wider'}>{b}</span>
          </React.Fragment>
        ))}
      </div>

      <div className="bg-white border border-gray-200 p-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-0">
          {items.map((item, idx) => (
            <button
              key={idx}
              onClick={() => item.path && navigate(item.path)}
              className={`flex items-center gap-4 py-5 border-b border-gray-100 text-left hover:bg-gray-50/50 transition-colors w-full group ${
                item.disabled ? 'opacity-40 cursor-not-allowed' : 'cursor-pointer'
              }`}
              disabled={item.disabled}
              data-testid={`hub-item-${item.id || item.label.toLowerCase().replace(/\s+/g, '-')}`}
            >
              <div className="w-8 h-8 flex items-center justify-center text-[#2563EB] flex-shrink-0">
                {item.icon && <item.icon className="w-5 h-5" />}
              </div>
              <span className="text-sm font-medium text-gray-800 flex-1 group-hover:text-[#1f1f1f]">
                {item.label}
              </span>
              <ChevronDown className="w-4 h-4 text-gray-300 flex-shrink-0" />
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AdminMenuGrid;
